export interface Riddle {
    id: string;
    question: string;
    answer: string;
    custom?: boolean;
}

export const BASE_RIDDLES: Riddle[] = [
    {
        id: 'dwarf-elevator',
        question: 'Мужчина живёт на 18 этаже. Каждое утро он спускается на лифте на первый этаж и уходит на работу. Вечером, вернувшись, он поднимается на лифте только до 10 этажа, а дальше идёт пешком — кроме дождливых дней. Почему?',
        answer: 'Он карлик и не может дотянуться до кнопки выше 10 этажа. В дождливые дни у него есть зонт, которым он дотягивается до нужной кнопки.',
    },
    {
        id: 'icicle',
        question: 'В комнате на полу лежит мёртвый человек в луже воды. Окно открыто, рядом ничего подозрительного. Что произошло?',
        answer: 'Он повесился, встав на глыбу льда (сосульку), которая растаяла — верёвка выдержала, а опора исчезла.',
    },
    {
        id: 'hiccups',
        question: 'Человек заходит в бар и просит стакан воды. Бармен молча достаёт пистолет и наводит на него. Человек говорит «спасибо» и спокойно уходит. Почему?',
        answer: 'У посетителя была икота, и он хотел воды, чтобы её унять. Бармен напугал его пистолетом, икота от испуга прошла — вода больше не понадобилась.',
    },
    {
        id: 'chess',
        question: 'Два человека сыграли пять партий в шахматы. Каждый выиграл одинаковое количество раз, и ни одной ничьей не было. Как такое возможно?',
        answer: 'Они играли не друг против друга, а каждый — против третьего игрока.',
    },
    {
        id: 'lighthouse',
        question: 'Женщина нажала на кнопку, свет погас, и она легла спать. Утром она прочитала в газете, что из-за этого погибли люди — но не удивилась и не почувствовала вины. Как это возможно?',
        answer: 'Она смотритель маяка. Погасив маячный свет на ночь по расписанию, она невольно стала причиной крушения корабля, но сама не сделала ничего противозаконного.',
    },
    {
        id: 'parachute-desert',
        question: 'В пустыне нашли мёртвого мужчину. Рядом с ним лежал нераспечатанный свёрток. Как он умер?',
        answer: 'Он был парашютистом. Свёрток — запасной парашют. Основной не раскрылся, а запасным он не успел или не смог воспользоваться.',
    },
    {
        id: 'triplets',
        question: 'Двое родились в один и тот же час, в один день, месяц и год, у одной и той же матери — но они не близнецы. Как так?',
        answer: 'Они — двое из тройни (или большего количества детей, рождённых одновременно).',
    },
    {
        id: 'polar-bear',
        question: 'Мужчина построил дом, все четыре стены которого смотрят строго на юг. Вокруг дома ходит медведь. Какого цвета этот медведь?',
        answer: 'Белого — дом стоит на Северном полюсе, поэтому в какую сторону ни посмотри, везде юг, а там водятся только белые медведи.',
    },
    {
        id: 'deaf-parrot',
        question: 'Продавец в зоомагазине честно предупредил покупателя: «Этот попугай повторит любое слово, которое услышит, кроме одного». Покупатель купил попугая, и продавец не обманул. Как это возможно?',
        answer: 'Попугай глухой — он не может услышать вообще ни одного слова, поэтому технически «не может повторить одно слово» — то самое, что скажут после покупки.',
    },
    {
        id: 'water-shipwreck',
        question: 'Мужчина продавал стакан воды за большие деньги, и люди охотно платили, хотя рядом не было никакого дефицита воды в обычном смысле. Как это возможно?',
        answer: 'Дело происходило в открытом море: он продавал воду выжившим в спасательной шлюпке после кораблекрушения, где пресной воды взять было больше негде.',
    },
    {
        id: 'mother-surgeon',
        question: 'После аварии в больницу привезли отца и сына. Хирург, взглянув на мальчика, сказал: «Я не могу его оперировать — это мой сын». Но хирург не был отцом мальчика. Как это возможно?',
        answer: 'Хирург — мама мальчика.',
    },
    {
        id: 'fridge',
        question: 'В доме нет ни окон, ни дверей, но когда внутри нужен свет — он появляется сам, стоит только открыть стену. Что это за «дом»?',
        answer: 'Это не дом, а холодильник — при открытии дверцы автоматически включается лампочка.',
    },
    {
        id: 'albatross-soup',
        question: 'В ресторане мужчина заказал суп из альбатроса. Попробовав одну ложку, он побледнел, вышел на улицу и застрелился. Почему?',
        answer: 'Ранее он пережил кораблекрушение, и товарищи по несчастью кормили его мясом, говоря, что это альбатрос. Попробовав настоящего альбатроса, он понял, что вкус совсем другой — и осознал, что тогда на самом деле ел человеческое мясо.',
    },
    {
        id: 'balloon-match',
        question: 'На необитаемом острове нашли тело мужчины со сгоревшей спичкой в руке. Рядом никаких других улик. Как он погиб?',
        answer: 'Он летел на воздушном шаре вместе с ещё одним человеком. Шар начал терять высоту, и, чтобы облегчить его и спасти хотя бы одного, они тянули спички: короткая — прыгать за борт без парашюта.',
    },
];
